<template>
    <div class="agent-chat__response" v-html="rendered"></div>
</template>

<script>
import { marked } from 'marked';
import DOMPurify from 'dompurify';

export default {
    name: 'AgentChatResponse',
    props: {
        source: {
            type: String,
            default: '',
        },
    },
    computed: {
        rendered() {
            const safeSource = this.closeIncompleteFences(this.source || '');
            const html = marked.parse(safeSource, { breaks: true, gfm: true });

            return DOMPurify.sanitize(html);
        },
    },
    methods: {
        // While streaming, an odd number of ``` fences means a code block is
        // still open; temporarily close it so markdown does not break layout.
        closeIncompleteFences(source) {
            const fenceCount = (source.match(/```/g) || []).length;

            if (fenceCount % 2 !== 0) {
                return `${source}\n\`\`\``;
            }

            return source;
        },
    },
};
</script>

<style scoped>
.agent-chat__response {
    overflow-wrap: anywhere;
    word-break: break-word;
}

.agent-chat__response :deep(p) {
    margin: 0 0 0.5em;
}

.agent-chat__response :deep(p:last-child) {
    margin-bottom: 0;
}

.agent-chat__response :deep(pre) {
    background: #1e1e1e;
    color: #f8f8f2;
    padding: 12px;
    border-radius: 6px;
    overflow-x: auto;
    margin: 0 0 0.5em;
}

.agent-chat__response :deep(code) {
    font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
    font-size: 0.9em;
}

.agent-chat__response :deep(:not(pre) > code) {
    background: rgba(0, 0, 0, 0.07);
    padding: 0.1em 0.35em;
    border-radius: 4px;
}

.agent-chat__response :deep(a) {
    color: #2563eb;
    text-decoration: underline;
}

.agent-chat__response :deep(ul),
.agent-chat__response :deep(ol) {
    margin: 0 0 0.5em;
    padding-left: 1.4em;
}

.agent-chat__response :deep(table) {
    border-collapse: collapse;
    margin: 0 0 0.5em;
}

.agent-chat__response :deep(th),
.agent-chat__response :deep(td) {
    border: 1px solid rgba(0, 0, 0, 0.15);
    padding: 4px 8px;
}
</style>
